import { Flex, Heading, VStack, Image, Text, Stack } from '@chakra-ui/react';
import { LandingPageLayout } from 'Layouts/LandingPageLayout';
import React from 'react';
import { IJumbotronContents } from 'Types/Interface/ILandingPage';
import { Jumbotron } from './Components/Jumbotron';
import { CostOfReliance } from './CostOfReliance';
import { CTA } from './CTA';
import { Customer } from './Customer';
import { GrowWithLoop } from './GrowWithLoop';
import { Services } from './Services';
import socialMedia from '../../Assets/svg/social-media-icon.svg';
import speedometer from '../../Assets/svg/speedometer.svg';
import userEngagement from '../../Assets/svg/user-engagement.svg';
import { useLoopBusinessLocalization } from 'Utils/localizationHooks';
import { MetaData } from 'Components/MetaData/Metadata';
import { Problem } from './Problem';
import { useLocale } from 'context/LocalizationContext';
import StorageService from 'Utils/storageService';

export const LoopForBusiness = () => {
	const {localization: loopBusinessLocalization} = useLoopBusinessLocalization();
	const { country, locale } = useLocale();
	
	const getCanonicalUrl = () => {
		if (typeof window !== 'undefined') {
			return `${window.location.origin}${window.location.pathname}`;
		}
		const countryCode = country?.url || StorageService.getCountryUrlOrDefault();
		const localeCode = locale || StorageService.getLanguageOrDefault();
		return `https://www.feedtheloop.com/${countryCode}/${localeCode}/loop-for-business`;
	};

	const getOgImage = () => {
		if (typeof window !== 'undefined') {
			return `${window.location.origin}/icon-512x512.png`;
		}
		return 'https://www.feedtheloop.com/icon-512x512.png';
	};

	const content:IJumbotronContents[] = [{
		heading : loopBusinessLocalization?.heroTitle,
		text: loopBusinessLocalization?.heroSubTitle,
		subText: 'Learn How It Works '
	}];

	return(
		<>
			<MetaData 
				title='Loop For Brands: Build Relationships with All Your Customers'
				description='Build a community of verified customers from all sales channels, gain actionable insights, and drive loyalty—on your terms.'
				keywords='customer engagement, brand marketing, customer loyalty, loyalty, actionable insights consumer insights, brand community, customer relationships'
				canonicalUrl={getCanonicalUrl()}
				ogImage={getOgImage()}
				ogUrl={getCanonicalUrl()}
				twitterSite='@Loop'
				lang={locale || 'en'}
				structuredData={{
					'@context': 'https://schema.org',
					'@type': 'SoftwareApplication',
					'name': 'Loop for Business',
					'description': 'Build a community of verified customers from all sales channels, gain actionable insights, and drive loyalty—on your terms.',
					'url': getCanonicalUrl(),
					'applicationCategory': 'BusinessApplication',
					'operatingSystem': 'Web',
					'audience': {
						'@type': 'BusinessAudience',
						'audienceType': 'Brands and Businesses'
					}
				}}
			/>
			<LandingPageLayout
				JumbotronSection={<Jumbotron contents={content}/>}
				paddingTop='0px'
				isBusiness
			>
				<GrowWithLoop loopBusinessLocalization={loopBusinessLocalization} shouldIgnoreParentPadding/>
				<Problem loopBusinessLocalization={loopBusinessLocalization} shouldIgnoreParentPadding />
				<CostOfReliance loopBusinessLocalization={loopBusinessLocalization} />
				<Stack
					direction={['column', 'row']}
					spacing={['20px', '40px']}
					align={'center'}
					justify={'center'}
					w={'100%'}
					// pt={['20px', '40px']}
					// px={['20px', '40px']}
				>
					<VStack align={['center']} justify={'center'} spacing={['20px','10px']}>
						<Heading textTransform={'uppercase'} fontSize={['30px', '30px']} textAlign={'center'}>
							What if you could own your customer relationships instead?
						</Heading>
					</VStack>
				</Stack>
				<Customer loopBusinessLocalization={loopBusinessLocalization} shouldIgnoreParentPadding />
				<VStack spacing={['20px', '50px']}  justify={'flex-start'} alignItems={'flex-start'}>
					<VStack spacing={'20px'}  justify={'center'} alignItems={'flex-start'} >
						<Heading textTransform={'uppercase'} fontWeight={'bold'}  w={['auto','620px']} fontSize={['30px', '40px']} >
							Engage Customers Like Never Before
						</Heading>
						<Text pb={['20px', null]}  fontSize={['16px','18px']}>Loop’s powerful tools help you connect, engage, and grow with your community.</Text>
					</VStack>
				

					<Flex direction={['column', null, null, 'row']} justifyContent={'space-between'}  w={['','full']}>
						<VStack mb={['28px', null]} borderRadius={'3px'} bg={'#ECEFF2'} align={'flex-start'}  w={['auto', null, null,'400px']} h={['auto', null, null,'300px']} p={['20px','30px']}>
							<Image src={socialMedia} mb={['20px','60px']} boxSize={'40px'} />
							<Heading textTransform={'uppercase'} fontWeight={'bold'} fontSize={'18px'} pb={'10px'}>{loopBusinessLocalization?.bridgingCampaignTitle}</Heading>
							<Text  fontSize={['16px','18px']}>{loopBusinessLocalization?.bridgingCampaignDescription}</Text>
							
						</VStack>
							
							
						<VStack mb={['28px', null]} borderRadius={'3px'} align={'flex-start'} bg={'#ECEFF2'}  w={['auto', null, null,'400px']}  h={['auto', null, null,'300px']} p={['20px','30px']}>
							<Image src={userEngagement} mb={['20px','60px']}  boxSize={'40px'} />
							<Heading textTransform={'uppercase'}  fontWeight={'bold'} fontSize={'18px'} pb={'10px'}>{loopBusinessLocalization?.engagementToolTitle}</Heading>
							<Text  fontSize={['16px','18px']}>{loopBusinessLocalization?.engagementToolDescription}</Text>
							
						</VStack>
							
						<VStack borderRadius={'3px'} align={'flex-start'}  w={['auto', null, null,'400px']}  bg={'#ECEFF2'} h={['auto', null, null,'300px']} p={['20px','30px']}>
							<Image src={speedometer} mb={['20px','60px']}  boxSize={'40px'} />
							<Heading textTransform={'uppercase'}  fontWeight={'bold'} fontSize={'18px'} pb={'10px'}>{loopBusinessLocalization?.performancePricingTitle}</Heading>
							<Text  fontSize={['16px','18px']} >{loopBusinessLocalization?.performancePricingDescription}</Text>
							
						</VStack>
					</Flex>
				</VStack>
				
				<Services loopBusinessLocalization={loopBusinessLocalization} shouldIgnoreParentPadding/>
				<CTA isCTA isBusiness ctaSubText={loopBusinessLocalization?.ctaSubtext} ctaText={loopBusinessLocalization?.ctaText} shouldIgnoreParentPadding />
			</LandingPageLayout>
		</>
	);
};